// extracted by mini-css-extract-plugin
export var details = "Work-module--details--2kFNh";
export var description = "Work-module--description--1O1I8";
export var date = "Work-module--date--2r1sU";
export var material = "Work-module--material--22q4i";
export var dimensions = "Work-module--dimensions--OYJmo";
export var info = "Work-module--info--16Ewk";